import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoginService } from '../../features/auth/login.service';

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  constructor(private http: HttpClient) {}
  baseUrl: string = environment.baseUrl;

  getAllOrdersUser(): Observable<any> {
    return this.http.post(`${this.baseUrl}/order/getorders`, {});
  }

  getAllOrders(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/order/getorders`, payload);
  }

  createOrder(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/order/createorder`, payload);
  }

  getConfirmedOrders(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/order/getconfirmedorder`, payload);
  }

  getConfirmedOrdersExport(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/order/getconfirmedorderexport`, payload);
  }

  updateOrder(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/order/updateorderstatus`, payload);
  }

  deleteOrder(id: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/order/deleteorder`, { id });
  }
}
